// Metallic Accent Treatment (new-theme.md 109a, Review Checklist 109a).
// Additive only: no colors change, built from existing accent tokens plus
// white/black overlays.
//
// The sheen is an animated CSS sweep, so the accent fill background MUST come
// from the `.metallic-sheen` CSS class (inline styles cannot declare keyframes
// or animate reliably). Inline-styled components apply METALLIC_SHEEN_CLASS via
// className and keep only their bevel/ring shadow inline via withBevel().

export const METALLIC_SHEEN_CLASS = "metallic-sheen";

export const METALLIC_BEVEL = "inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -2px 3px rgba(10, 54, 128, 0.4)";
export const METALLIC_RING = "inset 0 1px 1px rgba(255, 255, 255, 0.6), inset 0 -1px 2px rgba(10, 54, 128, 0.35)";

// Prepends the bevel to any existing box-shadow (keeps it, does not replace).
export const withBevel = (existingShadow) => [METALLIC_BEVEL, existingShadow].filter(Boolean).join(", ");
